<template>

  <div class="container">
    <div class="swiper-button-prev prev swiper-button-black" />
    <div class="swiper-button-next next swiper-button-black" />
    <div id="swiper-shop" class="swiper-container">
      <div class="swiper-wrapper">
        <div v-for="(shop,index) in shops" :key="index" class="swiper-slide">
          <span>
            <a href="javascript:void(0)" @click="goto(shop.id)">
              <img :src="shop.logo" class="shop-img" alt="店铺图片">
            </a>
            <div><a href="javascript:void(0)" @click="goto(shop.name)">{{ shop.name }}</a></div>
          </span>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination" />
      <!-- 如果需要导航按钮 -->

    <!-- 如果需要滚动条 -->
    </div>

  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'
export default {
  props: {
    shops: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.initSwiper()
  },
  methods: {
    initSwiper () {
      const mySwiper = new Swiper('#swiper-shop', {
        loop: true,
        autoplay: true,
        delay: 5000,
        loopedSlides: 5,
        slidesPerView: 5,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        onSlideChangeEnd: function (swiper) {
          swiper.update()
          mySwiper.startAutoplay()
          mySwiper.reLoop()
        }
      })
      console.log(mySwiper)
    },
    goto (shopId) {
      console.log(shopId, 'shopname')
      this.$router.push({ name: 'purchase', params: { maker: shopId }})
    }
  }
}
</script>

<style scoped>
.container{
  width: 100%
}
.swiper-container {
    width: 1160px;
    height: 300px;
}
.swiper-slide a:first-child {
  display: block;
}
.swiper-slide a {
  color: #000;
  text-decoration: none;
}
.shop-img{
  margin-top: 20px;
  height: 200px;
  width: 200px;
  border: 5px solid #d7d7d7
}
.prev{
    color: #707070;
position: relative;
left: 50px;
outline: none;
top: 160px;
}
.next{
  color: #707070;
  outline: none;
  position: relative;
top: 138px;
left: 1218px;

}
.swiper-button-prev{
   color: #707070;
}
</style>
